import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from './CircularProgress';
import LinearProgress from './LinearProgress';
import ImageListShimmer from './ImageListShimmer';

const ProgressBar = ({ type, ...props }) => {
  let ProgressComponent;

  switch (type) {
    case 'circular': {
      ProgressComponent = CircularProgress;
      break;
    }
    case 'linear': {
      ProgressComponent = LinearProgress;
      break;
    }
    case 'image-list':
      ProgressComponent = ImageListShimmer;
      break;
    default:
      ProgressComponent = null;
  }

  return <ProgressComponent {...props} />;
};

ProgressBar.propTypes = {
  type: PropTypes.oneOf(['circular', 'linear', 'image-list']).isRequired,
};

export default ProgressBar;
